import './legacy/script';
import './legacy/map';

import * as React from 'react';
import { createRoot } from 'react-dom/client';
import AddOns from './components/add-ons';
import { AddOn, AddOnCategory } from './components/types';
import './cookie-consent';
import './popup';
import './datepicker';

const addOnLists: HTMLDivElement[] = [].slice.call(
	document.querySelectorAll('[data-addons-list]'),
);

addOnLists.forEach(listEl => {
	const data = JSON.parse(listEl.getAttribute('data-addons-list') || '{}');
	const items = data.addons as AddOn[];
	const categories = data.categories as AddOnCategory[];

	const root = createRoot(listEl);
	root.render(<AddOns items={items} categories={categories} />);
});
